import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { AddThirdPartyProviderSchema } from '../../schemas/addSchema'
import { useOnCompleted } from '../useOnCompleted'
import { toDTO } from './api/mapper'
import { CREATE_THIRD_PARTY_PROVIDER_WORKSPACE_BIDDER } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseCreateThirdPartyProviderWorkspaceBidder } from './types'

export const useCreateThirdPartyProviderWorkspaceBidder =
  (): UseCreateThirdPartyProviderWorkspaceBidder => {
    const { workspaceId } = useWorkspaceParam()
    const { onCompleted } = useOnCompleted()
    const [errors, setErrors] = useState<FieldErrors<AddThirdPartyProviderSchema>>({})

    const { mutateAsync } = useMutation<{ input: Variables }, Data>({
      mutation: CREATE_THIRD_PARTY_PROVIDER_WORKSPACE_BIDDER,
      onCompleted: async (data: Data, variables: { input: Variables }): Promise<void> => {
        setErrors(onCompleted(variables.input.bidderCode, data))
      },
    })

    const createThirdPartyProvider = async (data: AddThirdPartyProviderSchema): Promise<void> => {
      await mutateAsync({ input: toDTO({ ...data, workspaceId }) })
    }

    return { createThirdPartyProvider, thirdPartyProviderErrors: errors }
  }
